module.exports = __webpack_public_path__ + "img/2-warm.6d4ffad4.svg";